export const style = {
  wrapper: {
    boxShadow: `0px 15px 1px -15px rgba(0, 0, 0, 0.4)`,
    paddingBottom: `60px`,
    marginBottom: `60px`
  },
  spacer: {
    margin: `20px 0`,
    borderTop: `1px solid #ddd`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/News/partials/SingleArticle/style/main.js